import store from "@/store"
var db = new zango.Db('mydb', ["headers", "items"]);
var itemscollection = db.collection('items');

//var itemdate=db.collection("itemdate")
var activecollection = function (clct) {
    return db.collection(clct)
}
//数据更新函数
function renewcollection(data) {
    return new Promise((resolve, reject) => {
        itemscollection.remove({});
            itemscollection.insert(data).then(
                () => {
                    resolve(data);
                }
    
            );


    })

}




//数据筛选函数
function dbfilter(collection, pnames, pvalues, callback) {
    var ar = []
    var agg = []
    for (let i = 0; i < pnames.length; i++) {
        ar[i] = {};
        /*
        if(pvalues[i]===undefined){//if passed para is undefined using regex to make it match anything
  
          pvalues[i]={$regex:'[\s\S]*'}
        }
        */
        ar[i][pnames[i]] = pvalues[i]
        agg[i] = {}
        agg[i]["$match"] = ar[i]
    }

    var cursor = collection.aggregate(agg)
    return callback(cursor)
}



//group collection to get a form like [{x:"a",y:2},{x:"b",y:5}]
//本地处理日期数据，由于部分功能无法在本地实现，已由服务器进行处理，该function现在用于数据导出
function chartdataxy(x, y) {
    // let pipe={}
    // pipe._id="$"+x;
    // for(let i=0;i<y.length;i++){

    //     let start=JSON.stringify(y[i]).indexOf(':"$')+3
    //     let end=JSON.stringify(y[i]).indexOf('"}')
    //     let sumname=JSON.stringify(y[i]).slice(start,end)

    //     pipe[sumname]=y[i]
    // }
    let pipe = {}
    pipe._id = "$" + x;
    for (let i = 0; i < y.length; i++) {
        let name = y[i]
        pipe[name] = { $sum: "$" + y[i] }
    }//get as  { _id: "$" + x, 
    // data0:{$sum:"$qty"}
    // data1:{$sum:"$number"}

    return new Promise((resolve, reject) => {
        itemscollection.aggregate([
            // {
            //     $project:{
            //         chartdate:{
            //             $dateFromString:{
            //                 dateString: '$'+x,
            //             }
            //         }
            //     },
            // },
            {
                $group: pipe
                //  {
                //     _id:"$"+x,
                //     y: y[0]
                // }
            },
            { $sort: { _id: 1 } }
        ]
        ).toArray((err, doc) => {
            let data = JSON.stringify(doc).replace(/_id/gi, x)
            data = JSON.parse(data)
            //console.log(data)
            store.commit("setifremotechart", false)
            store.commit("setchartdataxy", data)
            resolve(data)
        })

    })
};

function chartdatatimes(x, y, doc) {
    let datas = []
    y.forEach(v => {
        let thedata = JSON.parse(JSON.stringify(doc))
        thedata.forEach((o, i) => {
            //将横坐标key值转换为x，将纵坐标转换成y
            Object.assign(o, { x: o[x] })
            delete Object.assign(o, { y: o[v] })[v];
        })
        datas.push(thedata)
    })
    //get as  
    //[
    // [{"x":2-1":"y":8,"b"：9},{"_id":2-2":"y":5,"b"：7},{"_id":2-3":"y":11,"b"：5}],
    // [{"x":2-1":"a":8,"y"：9},{"_id":2-2":"a":5,"y"：7},{"_id":2-3":"a":11,"y"：5}]
    //]
    store.commit("setchartdatatime", datas)
}

function chartdatagroup(x, y, doc) {
    return new Promise(resolve => {
        // chartdataxy(x, y)
        // .then(doc => {
        var datas = []
        for (let i = 0; i < y.length; i++) {
            datas[i] = []
        }
        var labels = []
        doc.forEach(obj => {
            y.forEach((val, i) => {
                obj[val] = Math.round(obj[val] * 1000) / 1000//保留三位小数
                datas[i].push(obj[val])
            })

            labels.push(obj[x])
        });
        // console.log(doc)
        store.commit("setchartmodel", "group")
        store.commit("setchartdatagroup", { labels: labels, datas: datas });
        store.commit("process", false); //数据加载结束

        resolve({ labels: labels, datas: datas })

        //get as datas:[[],[]]
        //})
    })

}

// function chartdatagroup_d(x, y) {
//     let pipe = {}
//     pipe._id = "$" + x;
//     for (let i = 0; i < y.length; i++) {
//         pipe["data" + i] = { $sum: "$" + y[i] }
//     }//get as  { _id: "$" + x, 
//     // data0:{$sum:"$qty"}
//     // data1:{$sum:"$number"}
//     return new Promise((resolve, reject) => {
//         activecollection("items").aggregate([
//             {
//                 $group:
//                     pipe
//                 //  { _id: "$" + x, 
//                 //  amount: y 
//                 // } 
//             },
//         ]
//         ).toArray((err, doc) => {
//             //var data = [];
//             var datas = []
//             for (let i = 0; i < y.length; i++) {
//                 datas[i] = []
//             }
//             var labels = []
//             doc.forEach(obj => {

//                 for (let i = 0; i < y.length; i++) {
//                     obj["data" + i] = Math.round(obj["data" + i] * 1000) / 1000//保留三位小数
//                     datas[i].push(obj["data" + i])
//                 }

//                 // //判断是否为日期，并格式化
//                 // var parsedDate = Date.parse(obj._id);
//                 // if (isNaN(obj._id) && !isNaN(parsedDate)) {
//                 //    obj._id=obj._id.split('T')[0]
//                 // }

//                 labels.push(obj._id)
//             });

//             store.commit("setifremotechart", false)
//             store.commit("setchartdatagroup", { labels: labels, datas: datas });
//             store.commit("process", false); //数据加载结束

//             resolve({ labels: labels, datas: datas })

//             //get as datas:[[],[]]

//         })

//     })

// }



function collectionsort(sortset) {
    return new Promise((resolve, reject) => {
        itemscollection.aggregate([
            { $sort: sortset }
        ]).toArray((err, docs) => {
            resolve(docs)
        })

    })

}

//初始化items
function renewitems() {
    itemscollection
        .find()
        .sort({ _id: 1 })
        .toArray((err, doc) => {
            store.commit("setitems", doc);
            store.commit("setdatainformation", { perpage: doc.length, totalresults: doc.length })
        });
}


export { renewitems, itemscollection, activecollection, renewcollection, dbfilter, chartdataxy, chartdatagroup, chartdatatimes, collectionsort }



// WEBPACK FOOTER //
// ./src/components/utility/indexdb.js